<template>
  <md-card
    @mouseleave.native="onMouseLeave"
    :data-count="hoverCount"
    class="md-card-chart"
  >
    <md-card-header
      @mouseenter.native="onMouseOver"
      :data-header-animation="headerAnimation"
      :class="[
        { hovered: imgHovered },
        { hinge: headerDown },
        { fadeInDown: fixedHeader },
        { animated: true },
        { [getClass(backgroundColor)]: true },
        { 'md-card-header-text': HeaderText },
        { 'md-card-header-icon': HeaderIcon },
      ]"
    >
      <div v-if="chartInsideHeader" :id="chartId" class="ct-chart"></div>
      <slot name="chartInsideHeader"></slot>
    </md-card-header>

    <md-card-content>
      <div
        @click="updateMoving"
        v-show="chartInsideContent"
        :id="chartId"
        class="ct-chart"
      ></div>
      <div
        class="md-card-action-buttons text-center"
        v-if="headerAnimation === 'true'"
      >
        <md-button
          class="md-danger md-simple fix-broken-card"
          @click="fixHeader"
          v-if="headerDown"
        >
          <slot name="fixed-button"></slot> Fix Header!
        </md-button>
        <slot name="first-button"></slot>
        <slot name="second-button"></slot>
        <slot name="third-button"></slot>
      </div>
      <slot name="content"></slot>
    </md-card-content>

    <md-card-actions v-if="!noFooter">
      <slot name="footer"></slot>
    </md-card-actions>
  </md-card>
</template>
<script>
export default {
  name: 'chart-card',
  props: {
    HeaderText: Boolean,
    HeaderIcon: Boolean,
    noFooter: Boolean,
    chartInsideContent: Boolean,
    chartInsideHeader: Boolean,
    chartType: {
      type: String,
      default: 'Line', // Line | Pie | Bar
    },
    headerAnimation: {
      type: String,
      default: 'true',
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    chartResponsiveOptions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    chartAnimation: {
      type: Array,
      default: () => {
        return [];
      },
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          labels: [],
          series: [],
        };
      },
    },
    backgroundColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hoverCount: 0,
      imgHovered: false,
      fixedHeader: false,
      chartId: 'no-id',
      moving: false,
    };
  },
  computed: {
    headerDown() {
      return this.hoverCount > 15;
    },
  },
  methods: {
    headerBack () {
      this.fixedHeader = false;
    },
    fixHeader () {
      this.hoverCount = 0;
      this.fixedHeader = true;

      setTimeout(this.headerBack, 480);
    },
    onMouseOver () {
      if (this.headerAnimation === 'true') {
        this.imgHovered = true;
        this.hoverCount++;
      }
    },
    onMouseLeave () {
      if (this.headerAnimation === 'true') {
        this.imgHovered = false;
      }
    },

    getClass (backgroundColor) {
      return 'md-card-header-' + backgroundColor + '';
    },
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart(Chartist) {
      var chartIdQuery = `#${this.chartId}`;
      Chartist[this.chartType](
        chartIdQuery,
        this.chartData,
        this.chartOptions,
        this.chartAnimation,
      );
    },
    /***
     * Assigns a random id to the chart
     */
    updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = `div_${randomInt}`;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    trackTooltip(data) {
      if (this.moving) {
        const tooltip = document.getElementById('chart-tooltip');
        const div = document.getElementById(this.chartId);
        const rect = div.getBoundingClientRect();
        tooltip.style.display = 'inline';
        const length = this.chartData.labels.length;
        const width = (rect.right - (rect.left + 80)) / length;
        const index = Math.floor(
          (data.clientX - rect.left - width / 2) / width,
        );
        const y = data.clientY - rect.top + 20 + 'px';
        const x =
          data.clientX -
          rect.left +
          30 -
          (index === length - 1 ? 170 : 0) +
          'px';
        if (index === length - 1) tooltip.classList.add('left');
        else tooltip.classList.remove('left');
        tooltip.style.top = y;
        tooltip.style.left = x;
        tooltip.innerHTML =
          this.chartData.labels[index] +
          '<br> ' +
          this.chartData.series.reduce((acc, el, i) => {
            return (
              acc +
              ' <br>' +
              this.chartData.legend[i] +
              ': ' +
              this.priceDisplay(el[index])
            );
          }, '');
      }
    },
    updateChart() {
      this.updateChartId();

      import('chartist')
        .then((Chartist) => {
          const ChartistLib = Chartist.default || Chartist;
          this.$nextTick(() => {
            this.initChart(ChartistLib);
          });
        })
        .then(() => {
          const div = document.getElementById(this.chartId);
          const tooltip = document.createElement('span');
          tooltip.setAttribute('id', 'chart-tooltip');

          tooltip.classList.add('tooltip');
          tooltip.classList.add('box-shadow');
          div.appendChild(tooltip);
          div.removeEventListener('mousemove', this.trackTooltip);
          div.addEventListener('mousemove', this.trackTooltip);

          div.removeEventListener('click', this.trackTooltip);
          div.addEventListener('click', this.trackTooltip);
          window.setTimeout(() => {
            const offset = 50;

            const lines = document.getElementsByClassName('ct-line');
            for (let i = 0; i < lines.length; i++) {
              lines[i].style.transform = `translateX(${offset}px)`;
            }

            const points = document.getElementsByClassName('ct-point');
            for (let i = 0; i < points.length; i++) {
              points[i].style.transform = `translateX(${offset}px)`;
            }
          }, 80);
        });
    },
    updateMoving() {
      this.moving = !this.moving;
      const tooltip = document.getElementById('chart-tooltip');
      if (this.moving) tooltip.classList.add('box-shadow');
      else tooltip.classList.remove('box-shadow');
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/md/_variables.scss';
.ct-bar:hover,
.ct-point:hover {
  stroke-width: 15px;
}
.ct-bar,
.ct-point {
  text-decoration: none;
  position: relative;
  cursor: pointer;
}
.tooltip {
  color: white;
  z-index: 100;
  display: none;
  position: absolute;
  padding: 1em;
  // border: 1px solid rgb(255, 255, 255);
  border-radius: 0em 0.5em 0.5em 0.5em;
  background-color: $brand-primary;
}
.tooltip.left {
  border-radius: 0.5em 0em 0.5em 0.5em;
}
.box-shadow {
  box-shadow: 0px 0px 1em rgb(146, 146, 146);
  padding: 1.2em;
}
.ct-series-a .ct-point,
.ct-series-a .ct-line,
.ct-series-a .ct-bar,
.ct-series-a .ct-slice-donut {
  stroke: $brand-primary;
}
</style>
